<template>
  <canvas id="ss-dashboard-chart" />
</template>

<script>
export default {
  name: 'SSDashboardChart',
  components: {
  },
  props: {
    /** Labels for the X axis (e.g. dates or periods) */
    labels: {
      type: Array,
      required: true,
      default: () => [],
    },
    /** Number of messages sent per label, plotted as a bar series */
    sentCounts: {
      type: Array,
      required: true,
      default: () => [],
    },
    /** Number of messages viewed per label, plotted as a bar series */
    viewedCounts: {
      type: Array,
      required: true,
      default: () => [],
    },
    /** Number of purchases per label, plotted as a bar series */
    purchasedCounts: {
      type: Array,
      required: true,
      default: () => [],
    },
  },
  data: () => {
    return {
      /** Chart.js instance currently rendered on the canvas */
      $_ssDC_chart: null,
      /** Chart.js options shared across all renders of this component */
      $_ssDC_options: {
        responsive: true,
        maintainAspectRatio: false,
        plugins: {
          tooltip: {
            backgroundColor: '#FFFFFF',
            titleColor: '#000000',
            bodyColor: '#000000',
            boxWidth: 16,
            boxHeight: 0,
            boxPadding: 8,
            padding: 32,
          },
          legend: {
            position: 'bottom',
            align: 'start',
            labels: {
              padding: 16,
              boxWidth: 16,
              boxHeight: 2,
            },
          }
        },
        scales: {
          x: {
            grid: {
              display: false,
            }
          },
          y: {
            type: 'linear',
            position: 'left',
          },
        },
        interaction: {
          mode: 'index',
          intersect: false,
        },
      },
    };
  },
  computed: {
    /**
     * Snapshot of all chart input props in one object for deep watching.
     * Chart.js does not react to prop changes by itself; watching this computed
     * detects updates to nested array elements (e.g. per-label counts).
     * @returns {{ labels: Array, sentCounts: Array, viewedCounts: Array, purchasedCounts: Array }}
     */
    $_ssDC_datasets() {
      return {
        labels: this.labels,
        sentCounts: this.sentCounts,
        viewedCounts: this.viewedCounts,
        purchasedCounts: this.purchasedCounts,
      };
    },
  },
  methods: {
    /**
     * Create a new Chart.js instance bound to the canvas element and return it.
     * Combines the bar series for sent, viewed, and purchased counts.
     * @returns {object} The newly created Chart.js instance.
     */
    $_ssDC_renderChart() {
      return new window.Chart(
        document.getElementById('ss-dashboard-chart'),
        {
          type: 'bar',
          data: {
            labels: this.labels,
            datasets: [
              {
                label: '送信数',
                data: this.sentCounts,
                categoryPercentage: .1,
                barPercentage: 1,
                maxBarThickness: 2,
                backgroundColor: '#10B4D5',
                borderColor: '#10B4D5',
                borderWidth: 2,
                order: 2,
              },
              {
                label: '閲覧数',
                data: this.viewedCounts,
                categoryPercentage: .1,
                barPercentage: 1,
                maxBarThickness: 2,
                backgroundColor: '#FF3CD1',
                borderColor: '#FF3CD1',
                borderWidth: 2,
                order: 2,
              },
              {
                label: '購入数',
                data: this.purchasedCounts,
                categoryPercentage: .1,
                barPercentage: 1,
                maxBarThickness: 2,
                backgroundColor: '#1FD125',
                borderColor: '#1FD125',
                borderWidth: 2,
                order: 2,
              },
            ]
          },
          options: this.$data.$_ssDC_options,
        },
      );
    },
    /**
     * Destroy the previously rendered chart (if any) and render a fresh one
     * so the canvas reflects the latest prop values.
     */
    $_ssDC_updateChart() {
      if (this.$data.$_ssDC_chart) {
        this.$data.$_ssDC_chart.destroy();
      }
      this.$data.$_ssDC_chart = this.$_ssDC_renderChart();
    },
  },
  mounted() {
    this.$_ssDC_updateChart();
  },
  watch: {
    $_ssDC_datasets: {
      /**
       * Rebuilds the chart when labels or any series data change.
       */
      handler() {
        this.$_ssDC_updateChart();
      },
      deep: true,
    },
  },
}
</script>
